import { AppSidebar } from '@/components/app-sidebar'

export const WorkspaceNavigation = () => {
	return <AppSidebar />
}
